module.exports = __webpack_public_path__ + "img/edificio-finanzas.13860be5.svg";